import { render } from "./Transports.vue?vue&type=template&id=f09a2d08"
import script from "./Transports.vue?vue&type=script&lang=js"
export * from "./Transports.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__